<template>
  <div>
    <publicHeader @child-event="myInfoEvent"></publicHeader>
    <studyHeader
      :subjectIndex="subjectIndex"
      :studyNav="studyNav"
      :myInfo="myInfo"
      :public="public"
    ></studyHeader>
    <div class="bg_gray subject_cont">
      <div class="w1200 radius8 bs bg_white main">
        <!-- <div class="test_screen cl_gray">
					<div class="test_screen_l f16px"><span class="inline">年级</span><i class="inline">：</i></div>
					<div class="test_screen_r tc">
						<span class="test_screen_list bg_gray" v-for="(item,index) in grade" :key="index" :class="{'on':item.gradeId==grade_cur.gradeId}" @click="gradeCheck(index)">{{item.gradeName}}</span>
					</div>
				</div>
				<div class="test_screen cl_gray">
					<div class="test_screen_l f16px"><span class="inline">学科</span><i class="inline">：</i></div>
					<div class="test_screen_r tc">
						<span class="test_screen_list bg_gray" v-for="(item,index) in subject" :key="index" :class="{'on':item.subjectName==subject_cur.subjectName}" @click="subjectCheck(index)">{{item.subjectName}}</span>
					</div>
				</div> -->
        <div class="left-box">
          <div class="tab-wrap">
            <div
              :class="['tab-item', tab_active == 0 ? 'active' : '']"
              @click="onChangeTab(0)"
            >
              教材同步
            </div>
            <!-- <div :class="['tab-item',tab_active==1 ? 'active':'']" @click="onChangeTab(1)">章节</div> -->
          </div>
          <div class="famous_screen_list select-wrap">
            <el-select
              v-model="version_cur"
              placeholder="全部"
              @change="versionSelect"
            >
              <el-option
                v-for="item in versionList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </div>
          <div
            class="task_video_nav radius8 mat20 cl_dark"
            v-if="chapter.length > 0"
          >
            <div
              class="task_nav_first mab20"
              v-for="(item, index) in chapter"
              :key="index"
            >
              <div
                class="task_nav_first_title f16px cur"
                @click="firstOpen(index)"
                :class="{ on: item.open }"
              >
                <img src="../../../static/select_right.png" class="mar5" />
                <span style="font-size: 14px">{{ item.gradeName }}</span>
              </div>
              <div
                class="task_nav_second mat10"
                v-for="(second, secondIndex) in item.subordinate"
                :key="secondIndex"
                v-if="item.open"
              >
                <div
                  class="task_nav_second_title cur"
                  @click="secondOpen(index, secondIndex)"
                  :class="{ on: second.open }"
                  :title="second.name"
                >
                  <img src="../../../static/select_right.png" class="mar5" />
                  <span style="font-size: 13px" class="clip">{{
                    second.name
                  }}</span>
                </div>

                <div
                  class="task_nav_three"
                  v-if="second.open"
                  v-for="(three, threeIndex) in second.subordinate"
                  :key="threeIndex"
                >
                  <div
                    class="task_nav_three_title task_nav_second_title clip mat10 cur"
                    @click="threeOpen(index, secondIndex, threeIndex)"
                    :class="{ on: three.open }"
                    :title="three.name"
                  >
                    <img src="../../../static/select_right.png" class="mar5" />
                    <span style="font-size: 13px" class="clip">{{
                      three.chapter
                    }}</span>
                  </div>
                  <div
                    v-if="three.open"
                    style="font-size: 13px"
                    v-for="(four, fourIndex) in three.subordinate"
                    :key="fourIndex"
                  >
                    <div
                      @click="
                        knowledgeCheck(
                          four.unit,
                          second.id,
                          three.chapter,
                          item.gradeId
                        )
                      "
                      class="task_nav_three_title clip mat10 cur"
                      :title="four.unit"
                      :class="{ on: four.unit == chapter_cur }"
                    >

                      <span  style="font-size: 13px;margin-left:10px" class="clip">{{ four.unit }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-box">
          <div class="task_video_screen">
            <div class="test_screen cl_gray">
              <div class="test_screen_l f16px">
                <span class="inline">课程定位</span><i class="inline">：</i>
              </div>
              <div class="test_screen_r tc">
                <span
                  class="test_screen_list bg_gray"
                  v-for="(item, index) in direction"
                  :key="index"
                  :class="{ on: item.id == direction_cur }"
                  @click="directionCheck(item.id)"
                  >{{ item.name }}</span
                >
              </div>
            </div>
            <div class="test_screen cl_gray" v-if="teacher.length > 0">
              <div class="test_screen_l f16px">
                <span class="inline">主讲老师</span><i class="inline">：</i>
              </div>
              <div class="test_screen_r tc">
                <span
                  class="test_screen_list bg_gray"
                  v-for="(item, index) in teacher"
                  :key="index"
                  :class="{ on: item.teacher_id == teacher_cur }"
                  @click="teacherCheck(item.teacher_id)"
                  >{{ item.name }}</span
                >
              </div>
            </div>
            <div class="test_screen cl_gray">
              <div class="test_screen_l f16px">
                <span class="inline">排序</span><i class="inline">：</i>
              </div>
              <div class="test_screen_r tc">
                <span
                  class="test_screen_list bg_gray"
                  v-for="(item, index) in order"
                  :key="index"
                  :class="{ on: item.type == order_cur }"
                  @click="orderCheck(item.type)"
                  >{{ item.name }}</span
                >
              </div>
            </div>
          </div>

          <div
            class="subject_cont_title cl_gray f16px mab20 mat40"
            v-if="list.length > 0"
          >
            共&nbsp;<span class="cl_yel">{{ total }}</span
            >&nbsp;个视频
          </div>
          <div class="subject_list_cont">
            <router-link
              :to="{ path: '/video', query: { id: item.id } }"
              v-for="(item, index) in list"
              :key="index"
              class="group_list bg_white radius8"
            >
              <img :src="item.pic" class="group_list_img radius8 block" />
              <div class="group_list_text">
                <div class="group_list_top flex">
                  <h3 class="f18px clip">{{ item.name }}</h3>
                  <p class="cl_violet">
                    <span>{{ item.video_num }}节</span><i>全</i>
                  </p>
                </div>
                <div class="group_list_btm flex f16px cl_gray mat15">
                  <p>
                    <img src="../../../static/icon_video.png" /><span>{{
                      item.browse_num
                    }}</span>
                  </p>
                  <!-- <p><img src="../../static/message.png" /><span>{{item.people}}</span></p> -->
                </div>
              </div>
            </router-link>
          </div>
          <div class="flex flex2" v-if="list.length > 0">
            <div class="famous_page_l f16px cl_gray"></div>
            <div class="famous_page_r cl_dark">
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="pageSize"
                :current-page="currentPage"
                :total="total"
              ></el-pagination>
            </div>
          </div>
          <div
            class="choice_empty tc f18px cl_gray"
            style="margin-top: 25%"
            v-if="!chapter_cur && chapter.length > 0"
          >
            <p>请选择章节</p>
          </div>
          <div
            class="choice_empty tc f18px cl_gray"
            style="margin-top: 25%"
            v-else-if="list.length == 0"
          >
            <p>找不到内容，请重新选择</p>
          </div>
        </div>
      </div>
    </div>
    <vfooter @child-event="publicEvent"></vfooter>
  </div>
</template>

<script>
import publicHeader from "../../components/header.vue";
import studyHeader from "../../components/study_header.vue";
import vfooter from "../../components/footer.vue";
export default {
  name: "subject",
  components: {
    publicHeader,
    studyHeader,
    vfooter,
  },
  props: {},
  data() {
    return {
      subjectIndex: false, //学科分类显示
      studyNav: -1, //导航
      myInfo: {},
      public: {},
      id: "",
      subject_cur: {}, //默认学科
      subject: [], //学科
      grade: [], //年级
      grade_cur: {}, //默认年级
      list: [],
      currentPage: 1, //当前页数
      pageSize: 20, //每页数量
      total: 0, //总页数
      tab_active: 0, //0知识点，1章节
      versionList: [],
      drop_active: -1,
      version_cur: "",
      chapter: [], //章节
      old_chapter: [],
      chapter_cur: "",
      direction: [
        {
          name: "全部",
          id: "",
        },
        {
          name: "基础",
          id: "基础",
        },
        {
          name: "提高",
          id: "提高",
        },
        {
          name: "拔尖",
          id: "拔尖",
        },
      ], //定位
      direction_cur: "",
      order: [
        {
          type: "rank",
          name: "默认",
        },
        {
          type: "is_pick",
          name: "推荐",
        },
        {
          type: "is_hot",
          name: "热门",
        },
        {
          type: "browse_num",
          name: "浏览数量",
        },
        {
          type: "add_time",
          name: "最新",
        },
      ], //排序
      order_cur: "rank",
      teacher: [], //教师
      teacher_cur: "",
      type: -1,
      firstOpenId: "",
      chapter_str: "",
      pack_type_id: "",
    };
  },
  mounted() {
    this.getSubject();
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
  },
  watch: {
    $route: {
      handler() {
        this.id = this.$route.query.id;
        this.getSubject();
      },
    },
  },
  methods: {
    myInfoEvent(data) {
      this.myInfo = data;
    },
    publicEvent(data) {
      this.public = data;
    },
    //学科
    getSubject() {
      this.$get("/api/material/get_subject_data", {}).then((res) => {
        this.subject = res.data;
        this.old_chapter = "";
        if (this.id == "") {
          this.subject_cur = this.subject[0];
        } else {
          for (let i = 0; i < this.subject.length; i++) {
            if (this.id == this.subject[i].subjectId) {
              this.subject_cur = this.subject[i];
            }
          }
        }
        this.getVersion();
      });
    },
    //版本
    // getVersion() {
    //   this.$get("/api/exercise/get_subject_chapter_edition_data", {
    //     subject_id: this.subject_cur.subjectId,
    //     token: localStorage.getItem("token"),
    //   }).then((res) => {
    //     this.versionList = res.data;
    //     if (this.versionList.length > 0) {
    //       this.drop_active = 0;
    //       this.version_cur = res.data[0].Id;
    //       this.old_chapter = "";
    //       this.getChapter();
    //     } else {
    //       this.drop_active = -1;
    //     }
    //   });
    // },
    //版本
    getVersion() {
      this.$get("/api/course/get_subject_chapter_edition_data", {
        subject_id: this.subject_cur.subjectId,
        pharse_id: localStorage.getItem("pharseId"),
        token: localStorage.getItem("token"),
      }).then((res) => {
        this.versionList = res.data;
        if (this.versionList.length > 0) {
          this.drop_active = 0;
          this.version_cur = res.data[0].Id;
          this.old_chapter = "";
          this.getChapter();
        } else {
          this.drop_active = -1;
        }
      });
    },
    //章节
    getChapter() {
      // this.$get("/api/course/get_chapter_data", {
      this.$get("/api/course/get_new_chapter_data", {
        token: localStorage.getItem("token"),
        subject_id: this.subject_cur.subjectId,
        edition_id: this.version_cur,
        pharse_id: localStorage.getItem("pharseId"),
      }).then((res) => {
        this.old_chapter = "";
        this.chapter = [];
        this.chapter_cur = "";
        this.list = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].open = false;
            if (res.data[i].subordinate.length > 0) {
              for (let j = 0; j < res.data[i].subordinate.length; j++) {
                res.data[i].subordinate[j].open = false;
                /////////////
                if (res.data[i].subordinate[j].subordinate.length > 0) {
                  for (
                    let l = 0;
                    l < res.data[i].subordinate[j].subordinate.length;
                    l++
                  ) {
                    res.data[i].subordinate[j].subordinate[l].open = false;
                  }
                }

                /////////
              }
            }
          }
          this.chapter = res.data;
          this.old_chapter = res.data;

          if (this.chapter_cur != "") {
            this.getTeacher();
          }
        }
      });
    },
    firstOpen(e) {
      console.log(e);
      if (this.chapter[e].open) {
        this.chapter[e].open = false;
      } else {
        this.chapter = JSON.parse(JSON.stringify(this.old_chapter));
        this.chapter = this.chapter.map((item, index) => {
          item.open = index == e ? true : false;
          return item;
        });
        this.firstOpenId = this.chapter[e].gradeId;
        this.type = 1;
        this.currentPage = 1;
        this.getTeacher();
        //  this.getVideo();
      }
    },
    secondOpen(index, secondIndex) {
      if (this.chapter[index].subordinate[secondIndex].open) {
        this.chapter[index].subordinate[secondIndex].open = false;
      } else {
        this.chapter = JSON.parse(JSON.stringify(this.old_chapter));

        this.chapter[index].open = true;
        this.firstOpenId = this.chapter[index].gradeId;
        this.pack_type_id = this.chapter[index].subordinate[secondIndex].id;
        this.chapter[index].subordinate[secondIndex].open = true;
        this.type = 2;
        this.currentPage = 1;
        this.getTeacher();
        //   this.getVideo();
      }
    },
    threeOpen(index, secondIndex, threeIndex) {
      if (
        this.chapter[index].subordinate[secondIndex].subordinate[threeIndex]
          .open
      ) {
        this.chapter[index].subordinate[secondIndex].subordinate[
          threeIndex
        ].open = false;
      } else {
        this.chapter = JSON.parse(JSON.stringify(this.old_chapter));

        this.chapter[index].open = true;
        this.chapter[index].subordinate[secondIndex].open = true;
        this.firstOpenId = this.chapter[index].gradeId;
        this.pack_type_id = this.chapter[index].subordinate[secondIndex].id;
        this.chapter_str =
          this.chapter[index].subordinate[secondIndex].subordinate[
            threeIndex
          ].chapter;
        this.chapter[index].subordinate[secondIndex].subordinate[
          threeIndex
        ].open = true;

        this.type = 3;
        this.currentPage = 1;
        this.getTeacher();
      }
    },
    knowledgeCheck(id, pack_type_id, chapter, gradeId) {
      this.type = 4;
      this.chapter_cur = id;
      this.firstOpenId = gradeId;
      this.chapter_str = chapter;
      this.currentPage = 1;
      this.pack_type_id = pack_type_id;
      this.getTeacher();
    },
    //年级
    getGrade() {
      this.$get("/api/material/get_grade_data", {
        id: localStorage.getItem("pharseId"),
      }).then((res) => {
        this.grade = res.data;
        this.grade_cur = this.grade[0];
        this.getVideo();
      });
    },
    //教师
    getTeacher() {
      this.teacher_cur = "";
      this.$get("/api/course/get_new_teacher_data", {
        token: localStorage.getItem("token"),
        // chapter_id: this.chapter_cur,
        edition_id: this.version_cur,
        type: this.type ? this.type : 4,
        subject_id: this.subject_cur.subjectId,
        grade_id: this.firstOpenId,
        pack_type_id: this.pack_type_id,
        chapter: this.chapter_str,
        unit: this.chapter_cur,
      }).then((res) => {
        if (res.data.length > 0) {
          res.data.unshift({ teacher_id: "", name: "全部" });
        }
        this.teacher = res.data;

        this.currentPage = 1;
        this.getVideo();
      });
    },
    //视频
    getVideo() {
      this.$get("/api/course/get_pack_new_list", {
        subject_id: this.subject_cur.subjectId,
        //grade_id: this.grade_cur.gradeId,
        page: this.currentPage,
        limit: this.pageSize,
        edition_id: this.version_cur,
        token: localStorage.getItem("token"),
        unit: this.chapter_cur,
        teacher_id: this.teacher_cur,
        direction: this.direction_cur,
        order: this.order_cur,
        type: this.type,
        grade_id: this.firstOpenId,
        chapter: this.chapter_str,
        pack_type_id: this.pack_type_id,
      }).then((res) => {
        this.list = [];
        this.list = res.data.data;
        this.total = res.data.total;
      });
    },
    //学科选择
    subjectCheck(e) {
      this.subject_cur = this.subject[e];
      this.currentPage = 1;
      this.old_chapter = "";
      this.getVersion();
    },
    //年级选择
    gradeCheck(e) {
      this.grade_cur = this.grade[e];
      this.getVideo();
    },

    handleSizeChange: function (size) {
      this.pageSize = size;
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getVideo();
    },
    //教程同步切换
    onChangeTab(index) {
      if (index != this.tab_active) {
        this.tab_active = index;
      }
    },
    //选择版本
    versionSelect(e) {
      this.version_cur = e;
      this.old_chapter = "";
      this.currentPage = 1;
      this.getChapter();
      //this.getChapter();
    },
    //选择课程定位
    directionCheck(e) {
      this.direction_cur = e;
      this.currentPage = 1;
      this.getVideo();
    },
    orderCheck(e) {
      this.order_cur = e;
      this.currentPage = 1;
      this.getVideo();
    },
    teacherCheck(e) {
      this.teacher_cur = e;
      this.currentPage = 1;
      this.getVideo();
    },
  },
};
</script>

<style scoped>
.select-wrap {
  margin-bottom: 18px;
}
.tab-wrap {
  width: 250px;
  border: 1px solid #afa9fe;
  height: 30px;
  margin-bottom: 18px;
  box-sizing: border-box;
  border-radius: 4px;
}
.tab-wrap .tab-item {
  float: left;
  width: 50%;
  height: 100%;
  line-height: 30px;
  text-align: center;
  color: #afa9fe;
  cursor: pointer;
}
.tab-wrap .tab-item.active {
  color: #fff;
  background: #afa9fe;
}
.left-box {
  float: left;
  width: 16%;
  min-width: 250px;
  margin-right: 4%;
  box-sizing: border-box;
  flex-shrink: 0;
}
.left-box .famous_screen_list .el-input__inner {
  border-radius: 4px;
  width: 250px;
}
.right-box {
  flex: 1;
  width: 0px;
  box-sizing: border-box;
}
.main::after {
  display: block;
  overflow: hidden;
  content: "";
  height: 0px;
  clear: both;
}
.main {
  display: flex;
  align-items: flex-start;
}
.flex2 {
  width: 100%;
  justify-content: center;
}
.group_list:nth-child(4n) {
  margin-right: 20px;
}
.group_list_text {
  padding: 15px 4px 0;
}
.group_list_top {
}
.group_list_top > h3 {
  max-width: 200px;
  flex: 1;
  width: 0;
  font-size: 15px;
}
.group_list_top .cl_violet {
  white-space: nowrap;
  flex-shrink: 0;
}
</style>
